import styled from "styled-components"
function Modal({ children, styles, show, transition }: any) {

    return (
        <div className="">
            {show ? (
                <>
                    <div
                        className={`${transition} justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-[99999] outline-none focus:outline-none`}
                    >
                        <div className={`relative my-6 mx-auto max-w-3xl bg-white ${styles}`}>
                            {/*content*/}
                            <div className="border-0 rounded-lg shadow-lg relative flex flex-col w-full outline-none focus:outline-none">
                                {children}
                            </div>
                        </div>
                    </div>

                    {/* BACKDROP */}
                    <div className="opacity-70 fixed inset-0 z-[9999] bg-black"></div>
                </>
            ) : null}
        </div>
    )
}

Modal.defaultProps = {
    styles : '',
    transition : 'scaleup'
}

export default Modal